import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import Responsive from './Responsive';

const checkmark = (
  <svg
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="12"
    viewBox="0 0 14 12"
    style={{ margin: '3px' }}
  >
    <path
      fill="#000"
      d="M2.298 3.952l5.527 5.684L5.527 12 0 6.315l2.298-2.363zM11.658 0L14 2.316 7.791 9.623 5.294 7.065 11.66 0z"
    />
  </svg>
);

const BetaTag = withProps({
  children: <FormattedMessage defaultMessage="Beta" id="pricingInfo.beta" />,
})(
  styled('span', null, "BetaTag", require("./FeatureListItem-BetaTag.module.scss"), "beta-tag", "betaTag"),
);

const styles = require('./FeatureListItem-styles.module.scss');

function FeatureListItem({ children, beta, ...props }) {
  return (
    <Responsive smDown>
      {isSmall => (
        <Layout
          as="div"
          {...props}
          pad={3}
          align="center"
          className={styles.listItem}
          direction={isSmall ? 'column' : 'row'}
        >
          {checkmark}
          <Layout
            align="center"
            pad={isSmall && 3}
            direction={isSmall ? 'column' : 'row'}
          >
            <span>{children}</span>
            {beta && <BetaTag small={isSmall} />}
          </Layout>
        </Layout>
      )}
    </Responsive>
  );
}

export default FeatureListItem;
